var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#434DF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.852 8.65-3.5-3.5c-.1-.1-.2-.15-.35-.15h-5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V9c0-.15-.05-.25-.15-.35zm-3.85-2.45 2.8 2.8h-2.8V6.2zm3 11.8h-8V6h4v3c0 .55.45 1 1 1h3v8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsActiveIcon);
export default __webpack_public_path__ + "static/media/reportsActiveIcon.11fcfa8481e9dc3294ea2e6455714345.svg";
export { ForwardRef as ReactComponent };